'use strict';

wbApp.controller('RegistrationsSummaryCtrl', ['$scope', '$filter', '$translate', '$q', 'reportsSvc', 'semesterSvc', 'groupSvc',
    'accountingBookSvc', 'localStorageService', 'securitySvc',
function ($scope, $filter, $translate, $q, reportsSvc, semesterSvc, groupSvc, accountingBookSvc,
    localStorageService, securitySvc) {

    $scope.semesterDataRange = 1; // 1 - semester, 2 - from to
    $scope.fromDate = moment().subtract(3, 'M').startOf('day').toDate();
    $scope.toDate = moment().startOf('day').toDate();

    if (localStorageService.isSupported) {
        $scope.semesterDataRange = localStorageService.get('semesterDataRange') || 1;
    }

    $scope.customFilter = { groups: [], accountingBooks: [] };

    $scope.groups = groupSvc.getAllAsync();
    $scope.accountingBooks = accountingBookSvc.getAllAsync();
    $scope.rawCourses = [];
    $scope.courses = [];

    function preFilter() {
        $q.all([$scope.rawCourses.$promise, $scope.groups.$promise, $scope.accountingBooks.$promise]).then(function () {
            var groupIDs = _.values($scope.customFilter.groups);
            var accountingBookIDs = _.values($scope.customFilter.accountingBooks);
            $scope.courses.length = 0;
            $scope.courses.push.apply($scope.courses,
                _.filter($scope.rawCourses, function (o) {
                    var ret = true;
                    if (groupIDs.length > 0) {
                        ret = ret && _.intersection(o.studentGroups, groupIDs).length > 0;
                    }
                    if (accountingBookIDs.length > 0) {
                        ret = ret && _.includes(accountingBookIDs, o.accountingBookID);
                    }
                    return ret;
                })
            );
        });
    }

    $scope.groupsCombo = {
        items: $scope.groups,
        displayExpr: 'name',
        valueExpr: 'groupID',
        showSelectionControls: true,
        maxDisplayedTags: 3,
        multiline: false,
        itemTemplate: 'customItem',
        placeholder: $translate.instant('TXT_LBL_SELECT_GROUPS'),
        bindingOptions: {
            value: 'customFilter.groups'
        },
    }

    $scope.onDataRangeChanged = function () {
        if (localStorageService.isSupported) {
            localStorageService.set('semesterDataRange', $scope.semesterDataRange);
        }

        if ($scope.semesterID != null) {
            loadData();
        }

        if ($scope.gridSettings.gridInstance) {
            if ($scope.semesterDataRange === 1) {
                $scope.gridSettings.gridInstance.columnOption("semesterColumn", "visible", false);
            } else {
                $scope.gridSettings.gridInstance.columnOption("semesterColumn", "visible", true);
            }
        }
    }

    function loadData() {
        if ($scope.semesterDataRange === 1) {
            $scope.rawCourses = reportsSvc.getCourseRegistrationSummaryForSemester($scope.semesterID);
        } else {
            $scope.rawCourses = reportsSvc.getCourseRegistrationSummaryForDateRange($scope.fromDate, $scope.toDate);
        }
        preFilter();
    }

    $scope.$watch('customFilter', function (newValue, oldValue) {
        preFilter();
    }, true);

    semesterSvc.getDefaultAsync()
        .then(function (semester) {
            $scope.semesterID = semester.id;
            loadData();
        });

    $scope.$on('refreshData', function (e, data) {
        if ($scope.semesterID) {
            loadData();
        }
    });

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            loadData();
        }
    }

    $scope.gridSettings = {
        name: 'registrationsSummary',
        shouldShowColumnChooser: true,
        columns: [
        {
            name: 'semesterColumn',
            dataField: 'semesterID',
            caption: $translate.instant('TXT_LBL_SEMESTER'),
            dataType: 'string',
            width: '120px',
            calculateCellValue: function (rowData) {
                return $filter('semester')(rowData.semesterID);
            },
            visible: $scope.semesterDataRange === 2
        },
        {
            dataField: 'studentID',
            caption: 'studentID',
            dataType: 'string',
            visible: false,
            width: '70px'
        },
        {
            dataField: 'subjectCategoryID',
            caption: $translate.instant('TXT_LBL_COURSE_TYPE'),
            dataType: 'string',
            encodeHtml: false,
            calculateCellValue: function (rowData) {
                return $filter('subjectCategory')(rowData.subjectCategoryID);
            },
            width: '70px'
        },
        { dataField: 'studentSurname', caption: $translate.instant('TXT_HUMAN_SURNAME'), dataType: 'string', width: '110px' },
        { dataField: 'studentName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string', width: '110px' },
        { dataField: 'courseFullName', caption: $translate.instant('TXT_LBL_COURSE'), dataType: 'string', sortOrder: 'desc', },
        { dataField: 'payments', caption: $translate.instant('TXT_LBL_PAYMENT'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '90px' },
        {
            dataField: 'studentBirthday',
            caption: $translate.instant('TXT_LBL_BIRTHDAY'),
            dataType: 'date',
            format: { date: 'short' },
            width: '70px',
            alignment: 'right'
        },
        {
            dataField: 'studentPersonalIDNumber',
            caption: $translate.instant('TXT_LAB_PERSONAL_ID_NUMBER'),
            dataType: 'string',
            width: '90px',
            visible: securitySvc.isInRole('Student.ProtectedView')
        },
        { dataField: 'nationality', caption: $translate.instant('TXT_LBL_NATIONALITY'), dataType: 'string', width: '40px' },
        {
            dataField: 'gender',
            caption: $translate.instant('TXT_LBL_GENDER'),
            dataType: 'string',
            calculateCellValue: function (rowData) {
                return $filter('gender')(rowData.gender);
            },
            width: '80px'
        },
        { dataField: 'operatorAddressCity', caption: $translate.instant('TXT_LBL_CITY'), dataType: 'string', width: '90px' },
        { dataField: 'operatorAddressStreet', caption: $translate.instant('TXT_LBL_STREET'), dataType: 'string', width: '140px' },
        { dataField: 'operatorAddressPostalCode', caption: $translate.instant('TXT_LBL_POSTAL_CODE'), dataType: 'string', width: '60px' },
        {
            dataField: 'firstAttendedLesson',
            caption: $translate.instant('TXT_LBL_FIRST_LESSON'),
            dataType: 'date',
            format: { date: 'short' },
            width: '70px',
            alignment: 'right'
        },
        {
            dataField: 'lastAttendedLesson',
            caption: $translate.instant('TXT_LBL_LAST_LESSON'),
            dataType: 'date',
            format: { date: 'short' },
            width: '70px',
            alignment: 'right'
        },
        { dataField: 'studentHealth', caption: $translate.instant('TXT_LAB_HEALTH'), dataType: 'string', width: '80px' }, 
        { dataField: 'studentAllergies', caption: $translate.instant('TXT_LBL_ALLERGIES'), dataType: 'string', width: '80px', visible: false },
        { dataField: 'registrationNote', caption: $translate.instant('TXT_NOTE'), dataType: 'string' },
        { dataField: 'operatorFullName', caption: $translate.instant('TXT_LBL_PARENT'), dataType: 'string' },
        {
            dataField: 'operatorPhone',
            caption: $translate.instant('TXT_LBL_PHONE'),
            dataType: 'string',
            calculateCellValue: function (rowData) {
                return $filter('phone')(rowData.operatorPhone);
            }
        },
        { dataField: 'operatorEmail', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string' },
        {
            dataField: 'registrationDate',
            caption: $translate.instant('TXT_SEC_CLIENT_COURSE_REGISTRATION'),
            dataType: 'date',
            format: { date: 'short' },
            width: '70px',
            visible: false,
            alignment: 'right'
        },
        {
            dataField: 'studentGroups',
            caption: $translate.instant('TXT_MENU_GROUPS'),
            dataType: 'object',
            calculateCellValue: function (rowData) {
                return $filter('groups')(rowData.studentGroups);
            },
            visible: false
        },
        {
            dataField: 'accountingBookID',
            caption: $translate.instant('TXT_LBL_ACCOUNTING_BOOK'),
            dataType: 'string',
            calculateCellValue: function (rowData) {
                return $filter('accountingBook')(rowData.accountingBookID);
            },
            visible: false
        },
        { dataField: 'courseTypeName', caption: $translate.instant('TXT_LBL_TYPE'), dataType: 'string', visible: false },
        { dataField: 'fromAge', caption: $translate.instant('TXT_LBL_FROM_AGE'), dataType: 'number', visible: false },
        { dataField: 'toAge', caption: $translate.instant('TXT_LBL_TO_AGE'), dataType: 'number', visible: false },
        { dataField: 'ageRangeName', caption: $translate.instant('TXT_LBL_AGE_RANGE'), dataType: 'string', visible: false },
        {
            dataField: 'idmConsentIssued',
            caption: $translate.instant('TXT_LBL_IDM_CONSENT'),
            dataType: 'date',
            format: { date: 'short' },
            width: '70px',
            alignment: 'right',
            visible: false
        },{
                dataField: 'studentCreatedAt',
                caption: $translate.instant('TXT_STUDENT_CREATED_AT'),
                dataType: 'date',
                format: { date: 'short' },
                width: '70px',
                visible: false,
                alignment: 'right'
        }, 
        { 
            dataField: 'operatorFullName2', 
            caption: $translate.instant('TXT_LBL_SECONDARY_CONTACT'), 
            dataType: 'string',
            visible: false, 
        },
        {
            dataField: 'operatorPhone2',
            caption: $translate.instant('TXT_LBL_PHONE2'),
            dataType: 'string',
            calculateCellValue: function (rowData) {
                return $filter('phone')(rowData.operatorPhone2);
            },
            visible: false,
        },
        { 
            dataField: 'operatorEmail2', 
            caption: $translate.instant('TXT_LBL_EMAIL2'), 
            dataType: 'string',
            visible: false,
        },
        ]
    }
}]);
